module.exports = __webpack_public_path__ + "img/IMG_4097.b8a642ba.jpeg";